
import Vue from 'vue'
import RContextMenu from '@/components/navigation/ContextMenu.vue'
import ProfileImage from '@/components/forms/ProfileImage.vue'
import { mapActions } from 'vuex'

export default Vue.extend({
  props: {
    photoURL: {
      type: String,
    },
    name: {
      type: String,
    },
  },
  name: 'UserContextMenu',
  components: {
    RContextMenu,
    ProfileImage,
  },
  methods: {
    ...mapActions({ logout: 'user/logOut' }),
  },
  computed: {
    items() {
      return [
        {
          text: 'My account',
          to: '/account',
          hasDivider: true,
        },
        {
          text: 'Log Out',
          action: this.logout,
        },
      ]
    },
  },
})
